module.exports = __webpack_public_path__ + "static/media/联通.c309b4e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/viedeo/联通.mp4
// module id = 2GHu
// module chunks = 1